<template>
  <section class="mt-4" v-if="users.length > 0">
        <h3 class="mx-4 p-4 text-lg font-bold">Referrals History</h3>
        <p class="m-4 p-4" v-if="users.length === 0">No referred users found yet.</p>
        <table class="w-full table-fixed" v-else>
            <thead>
                <tr class="border border-gray-light bg-gray-light">
                    <th class="w-3/12 uppercase text-xs text-left px-8 py-3">Date</th>
                    <th class="w-6/12 uppercase text-xs text-left px-4 py-3">User</th>
                    <th class="w-2/12 hidden md:table-cell uppercase text-xs text-right px-4 py-3">Qualified</th>
                </tr>
            </thead>
            <tbody>
                <tr class="border border-bottom border-gray-light" v-for="user in users" :key="user.id">
                    <td class="px-8 py-2">{{ user.since }}</td>
                    <td class="px-4 py-2 truncate">{{ user.email }}</td>
                    <td class="px-4 py-2 hidden md:table-cell text-right">
                        <font-awesome-icon :icon="['fas', 'check']" class="text-primary text-sm" v-if="user.is_qualified"></font-awesome-icon>
                        <font-awesome-icon :icon="['fas', 'clock']" class="text-gray-darker text-sm" v-else></font-awesome-icon>
                    </td>
                </tr>
            </tbody>
        </table>
    </section>
</template>

<script>
export default {
    data() {
        return {
            users: [],
        }
    },
    mounted() {
        this.loadReferredUsers();
    },
    methods: {
        loadReferredUsers() {
            axios.get('/api/ambassador/users')
                .then(response => {
                    this.users = response.data.data;
                })
                .catch(err => console.error);
        }
    }
}
</script>

<style>

</style>